import type {
  HomeVisionBannerRow,
  HomeVisionContent,
} from '../models/home-vision-content.model';
import { prepareVisionButtonHtml, prepareVisionTitleHtml } from './home-vision-html.util';

function normalizeOrden(row: HomeVisionBannerRow, index: number): number {
  const orden = row.orden;
  return typeof orden === 'number' && !Number.isNaN(orden) ? orden : index;
}

/**
 * Mapeo — registros `VisionNegocio` ordenados ASC:
 * - orden 0 → cabecera: `titulo` eyebrow, `nombreBoton` título HTML, `contenido` descripción específica
 * - orden 1 → CTA: `nombreBoton` botón HTML, `urlForward` URL
 */
export function mapVisionBannersToContent(
  rows: HomeVisionBannerRow[],
  fallback: HomeVisionContent
): HomeVisionContent {
  if (!rows?.length) {
    return { ...fallback };
  }

  const sorted = [...rows].sort(
    (a, b) => normalizeOrden(a, 0) - normalizeOrden(b, 0)
  );

  const headerRow = sorted.find((row) => normalizeOrden(row, -1) === 0) ?? sorted[0];
  const ctaRow = sorted.find((row) => normalizeOrden(row, -1) === 1);

  const eyebrowRaw = headerRow?.titulo?.trim();
  const titleRaw = headerRow?.nombreBoton?.trim();
  const descripcionRaw = headerRow?.contenido?.trim();
  const buttonLabelRaw = ctaRow?.nombreBoton?.trim();
  const buttonUrlRaw = ctaRow?.urlForward?.trim();

  return {
    eyebrow: eyebrowRaw || fallback.eyebrow,
    titleHtml: titleRaw ? prepareVisionTitleHtml(titleRaw) : fallback.titleHtml,
    descripcionEspecifica: descripcionRaw || fallback.descripcionEspecifica,
    buttonLabel: buttonLabelRaw
      ? prepareVisionButtonHtml(buttonLabelRaw)
      : fallback.buttonLabel,
    buttonUrl: buttonUrlRaw || fallback.buttonUrl,
  };
}

export function isExternalVisionUrl(url: string | null | undefined): boolean {
  // Misma regla que para-mi: cualquier http(s) abre en nueva pestaña.
  return /^https?:\/\//i.test((url ?? '').trim());
}
